import { render } from "./RenderedFile.vue?vue&type=template&id=fe79957c&scoped=true"
import script from "./RenderedFile.vue?vue&type=script&lang=js"
export * from "./RenderedFile.vue?vue&type=script&lang=js"

import "./RenderedFile.vue?vue&type=style&index=0&id=fe79957c&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe79957c"]])

export default __exports__